import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as myGlobals from "../modelos/globales.modelo";
import { cCliente, ICliente } from "../modelos/cliente.modelo";
import { environment } from "@environments/environment";
import { IFechaHorasLibres } from "app/modelos/fechahoraslibres.modelo";

@Injectable({
  providedIn: "root",
})
export class ApiAppService {
  private oHeader: HttpHeaders = new HttpHeaders({
    "Content-Type": "application/json",
    Accept: "application/json",
  });
  // private API_URL: string = environment.API_URL;
  private API_URL: string = environment.backends.URL_API_COMUN;

  // se omite la parte que va en en proxy
  // http://192.168.22.104:8000

  constructor(protected _oHttp: HttpClient) {}

  // Obtiene los datos del cliente a partir del token recibido en la url
  ObtenerClientePorToken(): Observable<cCliente> {
    return this._oHttp.get<cCliente>(
      this.API_URL + "/api/clientes/token/detail/",
    );
  }

  // Obtiene los datos del cliente a partir del nombre del subdominio en la url
  // Ej: http://citaprevia-donbenito.eadministracion.es
  ObtenerClientePorUrl(sUrlSubdominio: string): Observable<ICliente> {
    const sJSON: string = '{"url_frontal":"' + sUrlSubdominio + '"}';
    return this._oHttp.post<ICliente>(
      this.API_URL + "/api/clientes/url/detail/",
      JSON.parse(sJSON),
    );
  }

  // Obtiene todos los departamentos, sus horario y áreas de atención de un cliente
  ObtenerTodosLosDepartamentoHorarioAreas() {
    return this._oHttp.get<any>(
      this.API_URL +
        "/api/departamentos/horarios/areas/" +
        myGlobals.IdClienteActivo() +
        "/",
    );
  }

  // Obtiene todos los departamentos, sus áreas y su personal asociado
  ObtenerAreasPersonalPorDepartamento() {
    return this._oHttp.get<any>(
      this.API_URL +
        "/api/departamentos/areas/personal/" +
        myGlobals.IdClienteActivo() +
        "/",
    );
  }

  // Obtiene todos los trámites y documentos de un cliente
  ObtenerTodosLosDocumentosTramite(idArea: number) {
    let sarea = {};
    if (idArea > 0) {
      sarea = { id_area: idArea };
    }
    return this._oHttp.post<any>(
      this.API_URL +
        "/api/documentacion/tramites/cliente/" +
        myGlobals.IdClienteActivo() +
        "/",
      sarea,
    );
  }

  // Comprueba si existe un solicitante y además devuelve sus citas pendientes
  // Devuelve un objeto ISolicitanteCitasPendientes
  ObtenerCitasPendientesSolicitante(
    sNIF: string,
    sEMAIL: string,
  ): Observable<any> {
    const solicitante = {
      id_cliente: myGlobals.IdClienteActivo(),
      nif: sNIF,
      email: sEMAIL,
    };
    return this._oHttp.post(
      this.API_URL + "/api/citas/solicitante/",
      solicitante,
    );
  }

  // Crear cita
  CrearCita(sDatosCita: string): Observable<any> {
    return this._oHttp.post<any>(
      this.API_URL + "/api/citas/crear/",
      JSON.parse(sDatosCita),
    );
  }

  // Anulación de una cita
  AnularCita(iCita: number, AnulaPersonal: boolean): Observable<any> {
    let sbody = "";

    sbody = '"id_cliente":' + myGlobals.IdClienteActivo();
    sbody += ',"id_cita":' + iCita;
    sbody += ',"PERSONAL":' + AnulaPersonal;
    sbody = "{" + sbody + "}";

    return this._oHttp.post<any>(
      this.API_URL + "/api/citas/anularcita/",
      JSON.parse(sbody),
    );
  }

  getCitasDisponiblesPorDia(
    fecha: string,
    params: any,
  ): Observable<IFechaHorasLibres> {
    const url = `${this.API_URL}/api/${myGlobals.IdClienteActivo()}/citas/disponibles/${fecha}/`;
    return this._oHttp.get<IFechaHorasLibres>(url, { params });
  }
  // Obtiene los días disponibles para solicitar cita
  ObtenerDiasDisponibles(
    iArea: number,
    iPersona: number,
    FechaIni: number,
    HHIni: number,
    MMIni: number,
  ): Observable<any> {
    let sbody = "";

    sbody = '"id_area":' + iArea;
    sbody +=
      ',"FECHA_INI":"' +
      myGlobals.fechaAAAAMMDDtoAAAA_MM_DD(FechaIni.toString()) +
      '"';
    sbody +=
      ',"hora_ini":"' +
      HHIni.toString().padStart(2, "0") +
      ":" +
      MMIni.toString().padStart(2, "0") +
      ':00"';

    sbody += ',"id_persona":' + iPersona;
    sbody = "{" + sbody + "}";

    return this._oHttp.post<any>(
      this.API_URL +
        "/api/citas/disponibilidad/" +
        myGlobals.IdClienteActivo() +
        "/",
      JSON.parse(sbody),
    );
  }

  // Bloqueo de una precita
  BloquearPrecita(idPrecita: number, HHMM: string): Observable<any> {
    let sbody = "";

    sbody = '"id_pre_cita":' + idPrecita;
    sbody += ',"HORA_CITA":"' + HHMM + '"';
    sbody = "{" + sbody + "}";

    return this._oHttp.post<any>(
      this.API_URL + "/api/citas/bloquear/",
      JSON.parse(sbody),
    );
  }

  // Obtiene los representados de un solicitante
  ObtenerRepresentadosSolicitante(idSolicitante: number): Observable<any> {
    let sbody = "";

    sbody = '"IdCliente":' + myGlobals.IdClienteActivo();
    sbody += ',"id_solicitante":' + idSolicitante;
    sbody = "{" + sbody + "}";

    return this._oHttp.post<any>(
      this.API_URL + "/api/citas/representados/solicitante/",
      JSON.parse(sbody),
    );
  }

  // Obtiene los representados de un solicitante
  ObtenerSolicitante(sNIF: string): Observable<any> {
    let sbody = "";

    sbody = '"IdCliente":' + myGlobals.IdClienteActivo();
    sbody += ',"nif":"' + sNIF + '"';
    sbody = "{" + sbody + "}";

    return this._oHttp.post<any>(
      this.API_URL + "/api/solicitante/detail/",
      JSON.parse(sbody),
      { headers: this.oHeader },
    );
  }

  // Desbloqueo de una precita
  DesbloquearPrecita(idPrecitaBloqueo: number): Observable<any> {
    let sbody = "";

    sbody = '{"id_pre_cita_bloqueo":' + idPrecitaBloqueo + "}";

    return this._oHttp.post<any>(
      this.API_URL + "/api/citas/desbloquear/",
      JSON.parse(sbody),
    );
  }

  // Reenviar por email el detalle de la cita
  EnviarEmailCita(iCita: number, TextoemailHTML: string): Observable<any> {
    let sbody = "";

    sbody = '"id_cliente":' + myGlobals.IdClienteActivo();
    sbody += ',"id_cita":' + iCita;
    sbody +=
      ',"CONTENIDO_EMAIL":"' + TextoemailHTML.replace(/["]+/g, "'") + '"';
    sbody = "{" + sbody + "}";

    return this._oHttp.post<any>(
      this.API_URL + "/api/citas/enviaremail/",
      JSON.parse(sbody),
    );
  }
}
